import { db } from '@core/db';
import { SectionContent } from '@/types';
import { pickCanonicalSectionContent } from '@/shared/utils/sectionContentCanonical';

async function computeHash(text: string): Promise<string> {
  const { hashText } = await import('@/shared/utils/crypto');
  return hashText(text || '');
}

export const sectionContentsRepo = {
  async get(sectionId: string, versionId: string) {
    const list = await db.sectionContents.where({ sectionId, versionId }).toArray();
    if (list.length > 1) {
      console.warn('[sectionContentsRepo] Múltiples contenidos para section+version — eligiendo el más rico', { sectionId, versionId, count: list.length });
    }
    return pickCanonicalSectionContent(list);
  },
  async getOrCreate(sectionId: string, versionId: string, factory: () => Omit<SectionContent, 'id'> & { id: string }) {
    const existing = await this.get(sectionId, versionId);
    if (existing) return existing;
    const data = factory();
    const nowIso = new Date().toISOString();
    const content = data.content || '';
    const hash = await computeHash(content);
    const record: SectionContent = {
      ...data,
      content,
      updatedAt: data.updatedAt ?? nowIso,
      contentHash: data.contentHash ?? hash,
      dirty: data.dirty ?? true,
    };
    await db.sectionContents.put(record);
    return record;
  },
  async updateContent(id: string, content: string) {
    const existing = await db.sectionContents.get(id);
    if (!existing) return;
    if ((existing.content ?? '') === content) return;
    const nowIso = new Date().toISOString();
    // Evita hash completo en cada pulsación; se recalcula de forma perezosa en preflight/push.
    await db.sectionContents.update(id, { content, updatedAt: nowIso, contentHash: undefined, dirty: true });
  }
};
